import {useState, useContext} from "react";
import {useParams} from "react-router-dom"
import GameBar from "./GameBar";
import SingleGameTable from "./SingleGameTable";
import ColorLabels from "./ColorLabels";
import { UserContext } from '../Context/UserContext';
import Glossary from "./Glossary";
import SingleGameTeamTrends from "./SingleGameTeamTrends";
import SignupLoginButtons from "./SignupLoginButtons";
import "../styles/singleGame.css"
import BatterIconLogo from "./BatterIconLogo";
import FormattedDate from "./FormattedDate";
import {useIsMobile} from "../hooks/useIsMobile"
import SingleGameMobileList from "./SingleGameMobileList";
import RatingDropDown from "./RatingDropDown";

function SingleGame() {
    const {home_team} = useParams()
    const {state, isActiveSub} = useContext(UserContext);
    //console.log('trends', state.teamTrends)
    //console.log('params home team', home_team)
    const [ratingTimeframe, setRatingTimeframe] = useState(false) //false is default (last 3 seasons), true is current season only
    const [showTeamInsights, setShowTeamInsights] = useState(true) //true shows them, false hides them
    //console.log('ratingTimeFrame', ratingTimeframe)
    const isMobile = useIsMobile(768)
    const relevantGame = state.games?.find((game) => String(game?.home_team) === String(home_team))
    const [showFullTable, setShowFullTable] = useState(false)
    const [showFullTablePrompt, setShowFullTablePrompt] = useState(true)

    function handleChange() {
        setRatingTimeframe(!ratingTimeframe)
    }
    
    function handleShowTeamInsights() {
        setShowTeamInsights(prevShowTeamInsights => !prevShowTeamInsights)
    }

    if (!home_team) {
        return (
            <h1>Loading...</h1>
        )
    }
    else
        return (
            <div>
                {!state.loggedIn && (
                    <div>
                        <BatterIconLogo logoID={"singleGameBatterIconLogo"} />
                        <div className="signUpLoginContainer">
                            <SignupLoginButtons />
                        </div>
                    </div>
                )}
                {isActiveSub && (
                    <div>
                        <BatterIconLogo logoID={"activeSubSingleGameBattersIconLogo"} />
                    </div>
                )}
                <h2 className="singleGameHeader">MLB Hitter and Pitcher Ratings</h2>
                <h3 className="singleGameHeaderTeams">{relevantGame?.away_team} vs {relevantGame?.home_team} on {<FormattedDate />}</h3>
                <GameBar />
                {isActiveSub && state.teamTrends.length > 0 && (
                    <div>
                        <RatingDropDown ratingTimeframe={ratingTimeframe} handleChange={handleChange} />
                        <br />
                        {ratingTimeframe === false && (<div className="teamInisghtsBtnContainer">
                            <button id="teamInsightsBtn" onClick={handleShowTeamInsights}>{showTeamInsights ? "Hide Team Insights" : "See Team Insights"}</button>
                        </div>)}
                        {showTeamInsights && <SingleGameTeamTrends relevantGame={relevantGame} trends={state.teamTrends} ratingTimeframe={ratingTimeframe}/>}
                    </div>
                )}
                {!isMobile && (<ColorLabels />)}
                {/* <Glossary /> */}
                {/* <br /> */}
                {isMobile ? (
                    <div>
                        <div className="mobileContainer">
                            {!showFullTablePrompt && ( <h3 className="changeViewHeader">Change View</h3>)}
                            <div className="promptBtnContainer">
                                <button onClick={() => setShowFullTablePrompt(prev => !prev)}>{showFullTablePrompt ? "-" : "+"}</button>
                            </div>
                            {showFullTablePrompt && (
                                <div className="promptHeaderContainer">
                                    <h2>{showFullTable ? "Go Back to Mobile List" : "Prefer the full table?"}</h2>
                                    <button onClick={() => setShowFullTable(prev => !prev)}>{showFullTable ? "View Mobile List" : "Show Full Table"}</button>
                                </div>
                            )}
                        </div>
                        <br />
                        {showFullTable ? (
                            <div>
                                <ColorLabels />
                                <SingleGameTable relevantGame={relevantGame} ratingTimeframe={ratingTimeframe}/>
                            </div>
                        ) : (
                            <SingleGameMobileList relevantGame={relevantGame} ratingTimeframe={ratingTimeframe} />
                        )}
                    </div>
                ) : (
                    <SingleGameTable relevantGame={relevantGame} ratingTimeframe={ratingTimeframe}/>
                )}
            </div>
        )
}

export default SingleGame